"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getInitialAsyncState(initialData) {
    return {
        loading: false,
        err: null,
        data: initialData ? initialData : null,
    };
}
exports.getInitialAsyncState = getInitialAsyncState;
function isAction(obj) {
    return typeof obj === 'object' && 'type' in obj && typeof obj.type === 'string' || typeof obj.type === 'symbol';
}
exports.isAction = isAction;
function isAsyncActionType(obj) {
    return obj && typeof obj.START === 'symbol' && typeof obj.ERR === 'symbol' && typeof obj.END === 'symbol';
}
exports.isAsyncActionType = isAsyncActionType;
function isLinkServiceConfig(obj) {
    return typeof obj.service === 'function' && isAsyncActionType(obj.type);
}
exports.isLinkServiceConfig = isLinkServiceConfig;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@awaw00/rxstore/lib/utils.js
// module id = 110
// module chunks = 0